import { BreadcrumbItem } from "@/types/shared";

export const countBreadcrumbs = (list: Omit<BreadcrumbItem, "position">[]): BreadcrumbItem[] =>
  list.map((item, idx) => ({ ...item, position: idx + 1 }));

export const stripTags = (value = "") => value.replace(/(<([^>]+)>)/gi, "");

export const parseEditorContentToString = (data: any) => {
  // TODO: refactor it
  if (data?.blocks && !!data?.blocks.length) {
    const blocks = data.blocks;
    const content = blocks.map(({ data, type }: any) => {
      if (type === "paragraph") return data?.text ? `<p>${data.text}</p>` : "";
      if (type === "list") {
        const renderListItemToString = (content: any, items: any, tag: any) => {
          const itemsContent = items
            .map(({ content, items }: any) => renderListItemToString(content, items, tag))
            .join("");

          return `<li>${content}${!!items.length ? `<${tag}>${itemsContent}</${tag}>` : ""}</li>`;
        };
        const listTag = data.style === "ordered" ? "ol" : "ul";
        const itemsContent = data.items
          .map(({ content, items }: any) => renderListItemToString(content, items, listTag))
          .join("");

        return `<${listTag}>${itemsContent}</${listTag}>`;
      }

      if (type === "raw") {
        return data.html;
      }
    });

    return stripTags(content.map((item: any) => (item ? item : "")).join(""));
  }
  return "";
};

export const prepareJsonLdString = (content: string | null) =>
  !!content ? content.replace(/"/g, '\\"') : "";

export const parseFAQAnswer = (data: string) => {
  try {
    return parseEditorContentToString(JSON.parse(data));
  } catch (err) {
    return data;
  }
};
